import { UPDATE_FILTER } from './moreInfosActions';

const initialState = {
  moreFilters: {},
};

export default function moreInfosReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case UPDATE_FILTER:
      return { ...state, moreFilters: payload };
    default:
      return state;
  }
}
